<form [formGroup]="regionForm" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="13"> </mat-spinner>
			</mat-icon>
			{{fieldLabel}}<span *ngIf="this.isMultiple">(s)</span>
		</mat-label>
		<mat-select placeholder="Select Regions" formControlName="regionSelect" *ngIf="this.isMultiple"
			(openedChange)="loadData($event)" (selectionChange)="select($event.value)" multiple [required]="required"
			[panelClass]="'panel-location-region'" [errorStateMatcher]="matcher" matInput>
			<mat-select-trigger>
				{{this.selectedRegionName}}
				<span *ngIf="selectRegionIds.length > 1">
					(+{{selectRegionIds.length - 1}} {{selectRegionIds.length === 2 ? 'other' :
					'others'}})
				</span>
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="primary" mat-raised-button (click)="selectAll()">
						Select All
					</button>
				</div>
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll()">
						Deselect All
					</button>
				</div>
			</div>

			<div class="text-center margin-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let region of this.filteredRegionsShow" [value]="region.ID">
					{{region.CODE}} {{region.NAME}}
				</mat-option>
			</div>
		</mat-select>

		<mat-select placeholder="Select Region" formControlName="regionSelect" *ngIf="!this.isMultiple"
			(openedChange)="!disabled && loadData($event)" (selectionChange)="select($event.value)"
			[required]="required" [panelClass]="'panel-location-region'">
			<mat-select-trigger *ngIf="selectRegionIds.length > 1">
				{{this.selectedRegionName}}
			</mat-select-trigger>

			<div class="padding-md text-center row gx-0">
				<div class="col">
					<button color="accent" mat-raised-button (click)="deSelectAll(); close();">
						Deselect
					</button>
				</div>
			</div>

			<div class="text-center padding-md" *ngIf="isLoading">
				<mat-icon>
					<mat-spinner diameter="13"> </mat-spinner>
				</mat-icon>
				Loading
			</div>

			<mat-option [hidden]="true">
				Select
			</mat-option>
			<div class="scrollable-panel-location" [hidden]="isLoading">
				<mat-option *ngFor="let region of this.filteredRegionsShow" [value]="region.ID">
					{{region.CODE}} {{region.NAME}}
				</mat-option>
			</div>
		</mat-select>
	</mat-form-field>
</form>